"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.filter.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _gridStyled = require("grid-styled");
var _datePicker = _interopRequireDefault(require("@gravity/date-picker"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _popUp = _interopRequireDefault(require("@gravity/pop-up"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _collapsiblePanel = _interopRequireDefault(require("@gravity/collapsible-panel"));
var _get = _interopRequireDefault(require("lodash/get"));
var _helpers = require("../../../../stx-widgets/v2/ProducerDashboard/helpers");
var _jsxFileName = "/codebuild/output/src3886550073/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ReportManagement/lib/ReportDateFilter.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1lfwt67qt1() {
  var path = "/codebuild/output/src3886550073/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ReportManagement/lib/ReportDateFilter.js";
  var hash = "0e0bb8376d903f83e98d26b02b17d7cbf92a81fc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3886550073/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ReportManagement/lib/ReportDateFilter.js",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 32
        },
        end: {
          line: 16,
          column: 48
        }
      },
      "1": {
        start: {
          line: 18,
          column: 26
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "2": {
        start: {
          line: 26,
          column: 27
        },
        end: {
          line: 26,
          column: 73
        }
      },
      "3": {
        start: {
          line: 37,
          column: 20
        },
        end: {
          line: 75,
          column: 1
        }
      },
      "4": {
        start: {
          line: 77,
          column: 28
        },
        end: {
          line: 84,
          column: 1
        }
      },
      "5": {
        start: {
          line: 78,
          column: 22
        },
        end: {
          line: 78,
          column: 88
        }
      },
      "6": {
        start: {
          line: 86,
          column: 36
        },
        end: {
          line: 92,
          column: 1
        }
      },
      "7": {
        start: {
          line: 91,
          column: 20
        },
        end: {
          line: 91,
          column: 99
        }
      },
      "8": {
        start: {
          line: 94,
          column: 21
        },
        end: {
          line: 116,
          column: 1
        }
      },
      "9": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 17
        }
      },
      "10": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 123,
          column: 6
        }
      },
      "11": {
        start: {
          line: 126,
          column: 22
        },
        end: {
          line: 128,
          column: 3
        }
      },
      "12": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 127,
          column: 61
        }
      },
      "13": {
        start: {
          line: 130,
          column: 20
        },
        end: {
          line: 133,
          column: 3
        }
      },
      "14": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 131,
          column: 34
        }
      },
      "15": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 132,
          column: 35
        }
      },
      "16": {
        start: {
          line: 135,
          column: 23
        },
        end: {
          line: 142,
          column: 3
        }
      },
      "17": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 138,
          column: 5
        }
      },
      "18": {
        start: {
          line: 137,
          column: 6
        },
        end: {
          line: 137,
          column: 13
        }
      },
      "19": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 141,
          column: 7
        }
      },
      "20": {
        start: {
          line: 147,
          column: 23
        },
        end: {
          line: 149,
          column: 3
        }
      },
      "21": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 35
        }
      },
      "22": {
        start: {
          line: 152,
          column: 61
        },
        end: {
          line: 152,
          column: 71
        }
      },
      "23": {
        start: {
          line: 153,
          column: 36
        },
        end: {
          line: 153,
          column: 46
        }
      },
      "24": {
        start: {
          line: 156,
          column: 6
        },
        end: {
          line: 162,
          column: 8
        }
      },
      "25": {
        start: {
          line: 160,
          column: 32
        },
        end: {
          line: 160,
          column: 64
        }
      },
      "26": {
        start: {
          line: 165,
          column: 29
        },
        end: {
          line: 172,
          column: 9
        }
      },
      "27": {
        start: {
          line: 175,
          column: 6
        },
        end: {
          line: 178,
          column: 12
        }
      },
      "28": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 192,
          column: 6
        }
      },
      "29": {
        start: {
          line: 196,
          column: 0
        },
        end: {
          line: 209,
          column: 2
        }
      },
      "30": {
        start: {
          line: 211,
          column: 0
        },
        end: {
          line: 218,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 26,
            column: 18
          },
          end: {
            line: 26,
            column: 19
          }
        },
        loc: {
          start: {
            line: 26,
            column: 27
          },
          end: {
            line: 26,
            column: 73
          }
        },
        line: 26
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 78,
            column: 13
          },
          end: {
            line: 78,
            column: 14
          }
        },
        loc: {
          start: {
            line: 78,
            column: 22
          },
          end: {
            line: 78,
            column: 88
          }
        },
        line: 78
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 91,
            column: 11
          },
          end: {
            line: 91,
            column: 12
          }
        },
        loc: {
          start: {
            line: 91,
            column: 20
          },
          end: {
            line: 91,
            column: 99
          }
        },
        line: 91
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 119,
            column: 2
          },
          end: {
            line: 119,
            column: 3
          }
        },
        loc: {
          start: {
            line: 119,
            column: 21
          },
          end: {
            line: 124,
            column: 3
          }
        },
        line: 119
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 126,
            column: 22
          },
          end: {
            line: 126,
            column: 23
          }
        },
        loc: {
          start: {
            line: 126,
            column: 28
          },
          end: {
            line: 128,
            column: 3
          }
        },
        line: 126
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 130,
            column: 20
          },
          end: {
            line: 130,
            column: 21
          }
        },
        loc: {
          start: {
            line: 130,
            column: 30
          },
          end: {
            line: 133,
            column: 3
          }
        },
        line: 130
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 135,
            column: 23
          },
          end: {
            line: 135,
            column: 24
          }
        },
        loc: {
          start: {
            line: 135,
            column: 38
          },
          end: {
            line: 142,
            column: 3
          }
        },
        line: 135
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 147,
            column: 23
          },
          end: {
            line: 147,
            column: 24
          }
        },
        loc: {
          start: {
            line: 147,
            column: 29
          },
          end: {
            line: 149,
            column: 3
          }
        },
        line: 147
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 151,
            column: 2
          },
          end: {
            line: 151,
            column: 3
          }
        },
        loc: {
          start: {
            line: 151,
            column: 11
          },
          end: {
            line: 193,
            column: 3
          }
        },
        line: 151
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 160,
            column: 18
          },
          end: {
            line: 160,
            column: 19
          }
        },
        loc: {
          start: {
            line: 160,
            column: 32
          },
          end: {
            line: 160,
            column: 64
          }
        },
        line: 160
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 27
          },
          end: {
            line: 26,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 28
          },
          end: {
            line: 26,
            column: 33
          }
        }, {
          start: {
            line: 26,
            column: 37
          },
          end: {
            line: 26,
            column: 47
          }
        }, {
          start: {
            line: 26,
            column: 51
          },
          end: {
            line: 26,
            column: 60
          }
        }, {
          start: {
            line: 26,
            column: 65
          },
          end: {
            line: 26,
            column: 73
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 78,
            column: 57
          },
          end: {
            line: 78,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 78,
            column: 57
          },
          end: {
            line: 78,
            column: 72
          }
        }, {
          start: {
            line: 78,
            column: 76
          },
          end: {
            line: 78,
            column: 86
          }
        }],
        line: 78
      },
      "2": {
        loc: {
          start: {
            line: 136,
            column: 4
          },
          end: {
            line: 138,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 136,
            column: 4
          },
          end: {
            line: 138,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 136
      },
      "3": {
        loc: {
          start: {
            line: 165,
            column: 29
          },
          end: {
            line: 172,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 165,
            column: 29
          },
          end: {
            line: 165,
            column: 33
          }
        }, {
          start: {
            line: 166,
            column: 6
          },
          end: {
            line: 172,
            column: 8
          }
        }],
        line: 165
      },
      "4": {
        loc: {
          start: {
            line: 177,
            column: 9
          },
          end: {
            line: 177,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 177,
            column: 9
          },
          end: {
            line: 177,
            column: 25
          }
        }, {
          start: {
            line: 177,
            column: 29
          },
          end: {
            line: 177,
            column: 40
          }
        }, {
          start: {
            line: 177,
            column: 44
          },
          end: {
            line: 177,
            column: 97
          }
        }],
        line: 177
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0e0bb8376d903f83e98d26b02b17d7cbf92a81fc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1lfwt67qt1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1lfwt67qt1();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _ref = (cov_1lfwt67qt1().s[0]++, _stylingConstants.default),
  color = _ref.color,
  mediaQueries = _ref.mediaQueries;
var DatePickerWrapper = (cov_1lfwt67qt1().s[1]++, (0, _styledComponents.default)(_datePicker.default).attrs({
  className: 'stx-DatePicker'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  .g-mini-calendar {\n    width: inherit;\n\n  }\n  .g-DatePicker-date {\n    visibility: ", ";\n    .g-Icon {\n      display: none;\n    }\n    .g-Input-text {\n      text-align: center;\n      padding: 0.5em;\n    }\n  }\n"])), function (props) {
  cov_1lfwt67qt1().f[0]++;
  cov_1lfwt67qt1().s[2]++;
  return (cov_1lfwt67qt1().b[0][0]++, props) && (cov_1lfwt67qt1().b[0][1]++, props.date) && (cov_1lfwt67qt1().b[0][2]++, 'inherit') || (cov_1lfwt67qt1().b[0][3]++, 'hidden');
}));
var FilterPanel = (cov_1lfwt67qt1().s[3]++, (0, _styledComponents.default)(_collapsiblePanel.default).attrs({
  className: 'g-ReportFilter-button'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  display: block;\n\n  .g-CollapsiblePanel-header {\n    background: transparent;\n    .g-collapsiblePanel-header-title {\n      padding: 10px 0 10px 0;\n      margin-right: 3px;\n      color: ", ";\n      span {\n        vertical-align: top;\n        white-space: nowrap;\n      }\n    }\n    .g-collapsiblePanel-header-icon {\n      .g-Icon {\n        color: ", ";\n        height: 1.2rem;\n        width: 1.2rem;\n      }\n    }\n  }\n\n  &.g-ReportFilter-MultiDropDown {\n    .g-collapsiblePanel-header-title {\n      padding: 2px;\n      width: 100%;\n      span {\n        text-overflow: ellipsis;\n      }\n    }\n    .g-CollapsiblePanel-body {\n      display: none;\n    }\n  }\n"])), color.greyDarker, color.grey));
var FilterButtonWrapper = (cov_1lfwt67qt1().s[4]++, (0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: function className(props) {
    cov_1lfwt67qt1().f[1]++;
    cov_1lfwt67qt1().s[5]++;
    return "g-ReportFilter-button-container ".concat((cov_1lfwt67qt1().b[1][0]++, props.isDisable) && (cov_1lfwt67qt1().b[1][1]++, 'disabled'));
  }
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  &.disabled * {\n    color: ", ";\n  }\n"])), color.disabledText));
var CollapsiblePanelIconWrapper = (cov_1lfwt67qt1().s[6]++, (0, _styledComponents.default)(_icon.default).attrs({
  className: 'g-ReportFilter-CollapsiblePanel-Icon'
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  margin-right: 10px;\n  margin-bottom: 2px;\n  color: ", ";\n"])), function (props) {
  cov_1lfwt67qt1().f[2]++;
  cov_1lfwt67qt1().s[7]++;
  return (0, _get.default)(props.theme, 'dashboard.iconColor', _helpers.DashboardStyles.color.filter.iconColor);
}));
var PopUpWrapper = (cov_1lfwt67qt1().s[8]++, (0, _styledComponents.default)(_popUp.default).attrs({
  className: 'g-ReportFilter-PopUp'
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  box-sizing: border-box;\n\n  ", ";\n  .g-DatePicker-calendar {\n    .selectedDay {\n        background-color: ", ";\n    }\n  }\n"])), mediaQueries.tablet(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n    position: absolute;\n    top: inherit;\n    right: inherit;\n    bottom: inherit;\n    left: inherit;\n  "]))), _helpers.DashboardStyles.color.filter.selectedDateBgColor));
var ReportDateFilter = /*#__PURE__*/function (_PureComponent) {
  function ReportDateFilter(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ReportDateFilter);
    cov_1lfwt67qt1().f[3]++;
    cov_1lfwt67qt1().s[9]++;
    _this = _callSuper(this, ReportDateFilter, [props]);
    (0, _defineProperty2.default)(_this, "onCollapseChanged", (cov_1lfwt67qt1().s[11]++, function () {
      cov_1lfwt67qt1().f[4]++;
      cov_1lfwt67qt1().s[12]++;
      _this.changePopUpDisplay(!_this.state.isDatePickerVisible);
    }));
    (0, _defineProperty2.default)(_this, "onFilterChanged", (cov_1lfwt67qt1().s[13]++, function (date) {
      cov_1lfwt67qt1().f[5]++;
      cov_1lfwt67qt1().s[14]++;
      _this.props.onDateChange(date);
      cov_1lfwt67qt1().s[15]++;
      _this.changePopUpDisplay(false);
    }));
    (0, _defineProperty2.default)(_this, "changePopUpDisplay", (cov_1lfwt67qt1().s[16]++, function (isVisible) {
      cov_1lfwt67qt1().f[6]++;
      cov_1lfwt67qt1().s[17]++;
      if (_this.props.isDisable) {
        cov_1lfwt67qt1().b[2][0]++;
        cov_1lfwt67qt1().s[18]++;
        return;
      } else {
        cov_1lfwt67qt1().b[2][1]++;
      }
      cov_1lfwt67qt1().s[19]++;
      _this.setState({
        isDatePickerVisible: isVisible
      });
    }));
    /**
     * When the user click out of the popup, this is closed
     */
    (0, _defineProperty2.default)(_this, "handlePopUpOnClose", (cov_1lfwt67qt1().s[20]++, function () {
      cov_1lfwt67qt1().f[7]++;
      cov_1lfwt67qt1().s[21]++;
      _this.changePopUpDisplay(false);
    }));
    cov_1lfwt67qt1().s[10]++;
    _this.state = {
      isDatePickerVisible: false
    };
    return _this;
  }
  (0, _inherits2.default)(ReportDateFilter, _PureComponent);
  return (0, _createClass2.default)(ReportDateFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_1lfwt67qt1().f[8]++;
      var _ref2 = (cov_1lfwt67qt1().s[22]++, this.props),
        date = _ref2.date,
        hideBeforeDate = _ref2.hideBeforeDate,
        isDisable = _ref2.isDisable,
        defaultText = _ref2.defaultText;
      var _ref3 = (cov_1lfwt67qt1().s[23]++, this.state),
        isDatePickerVisible = _ref3.isDatePickerVisible;
      var filterComponent = (cov_1lfwt67qt1().s[24]++, /*#__PURE__*/_react.default.createElement(DatePickerWrapper, {
        embedded: true,
        showPastDates: true,
        date: date,
        onChange: function onChange(changeDate) {
          cov_1lfwt67qt1().f[9]++;
          cov_1lfwt67qt1().s[25]++;
          return _this2.onFilterChanged(changeDate);
        },
        hideBeforeDate: hideBeforeDate,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 156,
          columnNumber: 7
        }
      }));
      var textComponentBtn = (cov_1lfwt67qt1().s[26]++, (cov_1lfwt67qt1().b[3][0]++, date) && (cov_1lfwt67qt1().b[3][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
        value: date,
        day: "numeric",
        month: "short",
        year: "numeric",
        timeZone: "UTC",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 166,
          columnNumber: 7
        }
      })));
      var filterComponentBtn = (cov_1lfwt67qt1().s[27]++, /*#__PURE__*/_react.default.createElement("div", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 175,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(CollapsiblePanelIconWrapper, {
        size: 16,
        iconName: "calendar",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 176,
          columnNumber: 9
        }
      }), (cov_1lfwt67qt1().b[4][0]++, textComponentBtn) || (cov_1lfwt67qt1().b[4][1]++, defaultText) || (cov_1lfwt67qt1().b[4][2]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: 'gravity.FilterBar.date',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 177,
          columnNumber: 45
        }
      }))));
      cov_1lfwt67qt1().s[28]++;
      return /*#__PURE__*/_react.default.createElement(FilterButtonWrapper, (0, _extends2.default)({
        onClick: this.props.onClick,
        isDisable: isDisable
      }, this.props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 182,
          columnNumber: 7
        }
      }), /*#__PURE__*/_react.default.createElement(FilterPanel, {
        collapsed: !isDatePickerVisible,
        onCollapseChange: this.onCollapseChanged,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 183,
          columnNumber: 9
        }
      }, filterComponentBtn, /*#__PURE__*/_react.default.createElement(PopUpWrapper, {
        onClose: this.handlePopUpOnClose,
        visible: isDatePickerVisible,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 187,
          columnNumber: 11
        }
      }, filterComponent)));
    }
  }]);
}(_react.PureComponent);
cov_1lfwt67qt1().s[29]++;
ReportDateFilter.propTypes = {
  /* Date value */
  date: _propTypes.default.string.isRequired,
  /* Default text to display when date is not selected yet */
  defaultText: _propTypes.default.node,
  /* The function call when on click is fired */
  onClick: _propTypes.default.func,
  /* The function call when date change */
  onDateChange: _propTypes.default.func,
  /* Should disable (grey color and not trigger event click) */
  isDisable: _propTypes.default.bool,
  /* Hide all date before this date */
  hideBeforeDate: _propTypes.default.instanceOf(Date)
};
cov_1lfwt67qt1().s[30]++;
ReportDateFilter.defaultProps = {
  defaultText: null,
  onClick: null,
  onDateChange: null,
  date: null,
  isDisable: false,
  hideBeforeDate: null
};
var _default = exports.default = ReportDateFilter;